import { Notification } from '@components/Notification';
import { VendorContractViewModel } from '@typeDefinitions/vendorTypes';
import { createEffect, Show } from 'solid-js';

import { VendorCosts } from './VendorCosts';
import { VendorPayments } from './VendorPayments';
import { Vendor } from './Vendors';

type Props = {
  vendor: VendorContractViewModel;
  index: number;
  vendorError?: string;
};

export const VendorContainer = (props: Props) => {
  const isVoided = () => props.vendor.status === 'Void';
  let contentRef: HTMLDivElement | undefined;

  createEffect(() => {
    // inert blocks pointer and keyboard interaction for a voided vendor
    contentRef?.toggleAttribute('inert', isVoided());
  });

  return (
    <div class="rounded-sm shadow-sm p-2">
      <Show
        when={
          Boolean(props.vendorError) &&
          props.vendor.name === 'Falvey Shippers Insurance'
        }
      >
        <Notification type="error" text={props.vendorError} sxProps="mb-3!" />
      </Show>
      <div ref={contentRef} class={isVoided() ? 'opacity-60' : ''}>
        <Vendor {...props} />
        <VendorCosts {...props} />
        <VendorPayments {...props} />
      </div>
    </div>
  );
};
